import React from "react"
import Local from "../base-pages/local"

const LocalCN = () => {
  return <Local lang="cn" />
}

export default LocalCN
